import Vue from 'vue'
import Vuex from 'vuex'
import user from '@store/modules/user'
import loader from '@store/modules/loader'
import pedido from '@store/modules/pedido'
import popup from '@store/modules/popup'
import entorno from '@store/modules/entorno'
import ctacte from '@store/modules/ctacte'


Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {user,loader,pedido,popup,entorno,ctacte}
})



// WEBPACK FOOTER //
// ./src/store/index.js